import { render, staticRenderFns } from "./NotificationSetting.vue?vue&type=template&id=ee7fca36&scoped=true&"
import script from "./NotificationSetting.vue?vue&type=script&lang=js&"
export * from "./NotificationSetting.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSetting.vue?vue&type=style&index=0&id=ee7fca36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7fca36",
  null
  
)

export default component.exports